//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '-35px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {
    // setTimeout(() => {
    //   this.initBarChart()
    // }, 1000)
    this.$nextTick(function () {});
  },
  methods: {
    initBarChart: function initBarChart(title, value) {
      //	得到仪表盘
      var colorArray = [{
        top: '#ffa800',
        //黄
        bottom: 'rgba(248,195,248,.3)'
      }, {
        top: '#1ace4a',
        //绿
        bottom: 'rgba(100,255,249, 0.3)'
      }, {
        top: '#4bf3ff',
        //蓝
        bottom: 'rgba(135,183,255,.3)'
      }, {
        top: '#4f9aff',
        //深蓝
        bottom: 'rgba(11,42,84,.3)'
      }, {
        top: '#b250ff',
        //粉
        bottom: 'rgba(100,255,249,.3)'
      }];
      var option = {
        // backgroundColor: "#38445E",
        tooltip: {
          show: true,
          formatter: '{b} : {c}'
        },
        xAxis: {
          type: 'value',
          show: false
        },
        yAxis: {
          type: 'category',
          axisTick: {
            show: false,
            alignWithLabel: false,
            length: 5
          },
          inverse: 'true',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#fff'
            }
          },
          data: title
        },
        series: [{
          type: 'bar',
          label: {
            normal: {
              show: true,
              position: 'right',
              formatter: '{c}',
              color: '#fff'
            }
          },
          data: value,
          barWidth: '40px',
          barCategoryGap: '50%',
          itemStyle: {
            normal: {
              show: true,
              color: function color(params) {
                var num = colorArray.length;
                return {
                  type: 'linear',
                  colorStops: [{
                    offset: 0,
                    color: colorArray[params.dataIndex % num].bottom
                  }, {
                    offset: 1,
                    color: colorArray[params.dataIndex % num].top
                  }, {
                    offset: 0,
                    color: colorArray[params.dataIndex % num].bottom
                  }, {
                    offset: 1,
                    color: colorArray[params.dataIndex % num].top
                  }, {
                    offset: 0,
                    color: colorArray[params.dataIndex % num].bottom
                  }, {
                    offset: 1,
                    color: colorArray[params.dataIndex % num].top
                  }, {
                    offset: 0,
                    color: colorArray[params.dataIndex % num].bottom
                  }, {
                    offset: 1,
                    color: colorArray[params.dataIndex % num].top
                  }, {
                    offset: 0,
                    color: colorArray[params.dataIndex % num].bottom
                  }, {
                    offset: 1,
                    color: colorArray[params.dataIndex % num].top
                  }]
                };
              },
              barBorderRadius: 20,
              borderWidth: 0,
              borderColor: '#333'
            }
          }
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};